import styled from "styled-components";
import { theme } from "../theme";

export const StyledUserCard = styled.div`
	padding: 2rem 0.7rem;
	width: 100%;
	min-height: ${(props) => (props.short ? "auto" : "16rem")};
	border-radius: 0.4rem;
	background-color: #ffffff;
	position: relative;

	& > span:first-child {
		top: 1rem !important;
		right: 0.95rem !important;
		transform: none !important;
	}

	& .user-header {
		width: 100%;
		margin-bottom: ${(props) => (props.short ? "0" : "1.3rem")};

		display: flex;
		align-items: center;
		column-gap: 1.2rem;

		& div.user-picture {
			width: 5.4rem;
			height: 5.4rem;

			display: flex;
			align-items: center;
			justify-content: center;

			background-color: ${(props) => (props.color ? props.color : "cyan")};
			border-radius: 100rem;

			& > span {
				height: 1.7rem;
				width: min-content;

				color: #ffffff;
				text-transform: uppercase;
				font-family: ${theme.font.secondary};
				font-size: 2rem;
				font-weight: 500;

				display: block;
			}
		}

		& div:not(.user-picture) {
			display: flex;
			flex-direction: column;
			justify-content: center;
		}
	}

	& h5 {
		margin-top: 0.5rem;
		font-size: 1.2rem;
		font-weight: 500;
	}

	& > h5 {
		margin: 0.5rem 0.6rem 0;
	}

	& > span:last-of-type {
		margin: 0 0.6rem;
	}

	& span.user-label {
		font-size: 0.8rem;
		font-weight: 500;
		text-transform: uppercase;
		font-family: ${theme.font.secondary};
	}

	& .user-role-buttons {
		height: 3rem;
		margin: 1rem 0 0;

		display: flex;
		align-items: center;
		justify-content: flex-end;

		& > * {
			margin-left: 1rem;
			cursor: pointer;
		}
	}
`;
